<template>
  <div class="timespan-selector">
    <el-select v-if="isOrder" placeholder="类型" v-model="partType" size="mini" clearable>
      <el-option label="急件" value="1"></el-option>
      <el-option label="含税" value="2"></el-option>
    </el-select>
    <el-date-picker size="mini" :key="rangeType" :type="rangeType" range-separator="-" :unlink-panels="true" v-model="currentValue"></el-date-picker>
    <el-radio-group v-model="rangeType" size="mini">
      <el-radio-button label="daterange">日</el-radio-button>
      <el-radio-button label="monthrange">月</el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
export default {
  name: 'TimeSpan',
  model: {
    prop: 'timeSpan',
    event: 'change'
  },
  props: {
    timeSpan: {
      type: Object,
      default () {
        return {
          range: null,
          rangeType: 'daterange',
          isOrder: false,
          partType: undefined
        }
      }
    }
  },
  beforeMount () {
    this.currentValue = this.timeSpan.range
    this.rangeType = this.timeSpan.rangeType
    this.isOrder = this.timeSpan.isOrder
    this.partType = this.timeSpan.partType
  },
  data () {
    const now = new Date()
    const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    const startTime = new Date(now.getFullYear(), now.getMonth(), 1)
    return {
      currentValue: [startTime, endTime],
      rangeType: 'daterange',
      isOrder: false,
      partType: undefined
    }
  },
  watch: {
    rangeType (val) {
      if (val === 'daterange') {
        const now = new Date()
        const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
        const startTime = new Date(endTime.getTime() - 86400 * 31 * 1000)
        if (this.currentValue === null || (this.currentValue[1].getTime() - this.currentValue[0].getTime()) > 86400 * 31 * 1000) {
          this.currentValue = [startTime, endTime]
        }
      } else {
        const now = new Date()
        const endTime = new Date(now.getFullYear(), now.getMonth() + 1, 1)
        const startTime = new Date(now.getFullYear(), now.getMonth() - 12, 1)
        if (this.currentValue === null || (this.currentValue[1].getTime() - this.currentValue[0].getTime()) <= 86400 * 31 * 1000) {
          this.currentValue = [startTime, endTime]
        }
      }
    },
    currentValue (newVal, oldVal) {
      if (newVal) {
        if (newVal[1].getTime() - newVal[0].getTime() > 86400 * 31 * 1000) {
          if (this.rangeType === 'daterange') {
            this.rangeType = 'monthrange'
          }
        } else {
          if (this.rangeType === 'monthrange') {
            this.rangeType = 'daterange'
          }
        }
      }
      this.$nextTick(() => {
        this.$emit('change', {
          range: newVal,
          rangeType: this.rangeType,
          partType: this.partType
        })
      })
    },
    partType () {
      this.$emit('change', {
        range: this.currentValue,
        rangeType: this.rangeType,
        partType: this.partType
      })
    }
  }
}
</script>
